import Component from '@glimmer/component';
import { action } from '@ember/object';
import ENV from 'donor-elf-web/config/environment';
import FundSummaryModel from 'donor-elf-web/models/fund-summary';

interface ComponentArgs {
  fundSummary: FundSummaryModel;
  onSortBy: (property: string) => void;
}

export default class FundSummaryRollingGoalComponent extends Component<ComponentArgs> {
  get ytdGoal() {
    return this.args.fundSummary.ytdGoal!;
  }

  @action
  viewGivenAndExpectingReport() {
    window.location.href = `${ENV.rootURL}funds/${this.args.fundSummary.fundId}/ytd-given-expecting`;
  }
}
